import api from './api';

export const transaction = (user, inputs, config) => {
    let errors = [];
    if (!user) {
        errors.push('user');
    }
    if (!inputs) {
        errors.push('inputs');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.post(`/Transaction/AddTransaction/${user != null ? user?.id : ""}`, inputs, config);
    }
}
